module.exports = __webpack_public_path__ + "img/mc.6bb3a6ad.svg";